<template>
  <div>
    <v-dialog v-model="dialog" width="500px">
      <v-card class="confirmation-modal">
        <v-img
          class="modal-icon"
          width="84"
          :src="thumbsUpImage"
        />
        <h2 class="mt-8 mb-8">
          Thank you, your change kennel owner request has been submitted. You
          will be notified of approval.
        </h2>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogError" width="500px">
      <v-card class="confirmation-modal">
        <h2 class="mt-8 mb-8">
          {{ errorMessage }}
        </h2>
      </v-card>
    </v-dialog>
    <div class="top-icons">
      <a
        class="back-icon"
        v-on:click="
          updatePaymentInfo(paymentInfo);
          changePage(1);
        "
      >
        <font-awesome-icon icon="long-arrow-alt-left" size="lg" /> Back
      </a>
    </div>
    <h1 class="register-title">Change Kennel Owners Application</h1>
    <v-form class="register-form" v-model="isValid">
      <div class="table-gray-box">
        <table>
          <tr>
            <td>Change Kennel Owners</td>
            <td>${{ price }}</td>
            <v-tooltip bottom content-class="fee-table-tooltip">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on"
                  ><font-awesome-icon icon="info-circle"
                /></span>
              </template>
              <simple-fee-table :priceInfo="priceInfo" />
            </v-tooltip>
          </tr>
          <tr>
            <td>Total</td>
            <td>${{ price }}</td>
          </tr>
        </table>
      </div>
      <div class="table-gray-box">
        <h3>New Owners</h3>
        <CoownersList
          :owners="coOwnerInfo"
          :ownershipType="kennelOwnershipType"
          :hideHeader="true"
        />
      </div>
      <signature class="mt-3" :signature="sig" v-on:update="sig = $event">
        <template v-slot:signatureText>
          <kennel-signature-text />
        </template>
      </signature>
    </v-form>
    <v-overlay :value="processingRequest">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
    <hosted-registration-payment
      :disabled="!isValid || sig === '' || processingRequest || price === null"
      buttonText="SUBMIT"
      v-on:updatePaymentInfo="($event) => {
        processingRequest = true;
        submitRequest($event, sig);
      }"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { UserInfo } from "@/types/User";
import Signature from "@/components/common/inputs/Signature.vue";
import KennelSignatureText from "@/components/common/KennelSignatureText.vue";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";
import SimpleFeeTable from "@/components/common/SimpleFeeTable.vue";
import HostedRegistrationPayment from "@/components/common/HostedRegistrationPayment.vue";
import { getErrorMessage, getErrorResponse } from "@/services/errorHandler";

const thumbsUpImage = require('@/assets/thumbs-up-duotone.svg');

export default Vue.extend({
  name: "ChangeKennelOwnersForm2",
  data: function () {
    return {
      thumbsUpImage,
      dialog: false,
      dialogError: false,
      paymentInfo: this.paymentInfoProp,
      isValid: true,
      processingRequest: false,
      sig: this.$props.signature,
      errorMessage: ""
    };
  },
  components: {
    Signature,
    KennelSignatureText,
    CoownersList,
    SimpleFeeTable,
    HostedRegistrationPayment
  },
  props: {
    changePage: Function,
    coOwnerInfo: Array,
    submitRequest: Function,
    status: Object,
    paymentInfoProp: Object,
    updatePaymentInfo: Function,
    updateSignature: Function,
    signature: String,
    price: Number,
    priceInfo: Object,
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    kennelOwnershipType: function () {
      return OwnershipType.Kennel;
    },
  },
  watch: {
    status: function (newVal: any, oldVal: any) {
      if (newVal?.success) {
        this.openModal();      
      } else {
        this.errorMessage = getErrorMessage(newVal);
        this.openErrorModal();
      }
    },
    dialog: function (newVal: boolean, oldVal: boolean) {
      if (!newVal) {
        this.$store.dispatch("loadPersonTasks");
        this.$navigate("/");
      }
    },
    dialogError: function (newVal: boolean, oldVal: boolean) {            
      if (!newVal && getErrorResponse(this.status)?.data?.paymentIssue) {
        this.processingRequest = false;
        this.$store.dispatch("loadPersonTasks");
        this.$navigate("/");
      } else if (!newVal) {
        this.processingRequest = false;
      }
    },
  },
  methods: {
    openModal: function () {
      this.$data.dialog = true;
    },
    openErrorModal: function () {
      this.$data.dialogError = true;
    },
  },
});
</script>
